import { render } from "./ProfessorForm.vue?vue&type=template&id=772e1e49"
import script from "./ProfessorForm.vue?vue&type=script&lang=js"
export * from "./ProfessorForm.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__